import type { ResolveInviteError } from "../api/use-resolve-invite";

export type ErrorCardVariant = "invalid-invite" | "network";

// Missing URL params are treated the same as an invalid invite — both mean the link can't be resolved.
export const toErrorCardVariant = (error: ResolveInviteError): ErrorCardVariant =>
  error === 503 ? "network" : "invalid-invite";
